var React = require('react');
var StatsTable = require('./StatsTable.jsx');
var TeamCompareHeader = require('./TeamCompareHeader.jsx');
var VisPercent = require('./VisPercent.jsx');

var KickPassRun = React.createClass({
    render : function(){
        return (
            <article className="sub-module equal-height height-reset" style={{"height": "238px"}}>
                <header className="bordered"><h1>Kick/Pass/Run</h1></header>
                <div className="content">
                    <TeamCompareHeader heading="Metres Run" home={this.props.home} away={this.props.away} />
                    <VisPercent colors={this.props.colors} values={this.props.values} percent={this.props.percent}/>
                    <StatsTable stats={this.props.kickPassRunStats} />
                </div>
            </article>
        );
    }
});

module.exports = KickPassRun;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/KickPassRun.jsx
 **/